/**
 * Given a list of lists, returns a flattened version of the list.
 *
 * @param parts A list of lists to flatten
 * @returns A flattened version of the list
 */
export const collapseList = <T>(parts: T[][]): T[] => parts.reduce((acc, next) => acc.concat(next), []);

/**
 * Equivalent to reduce array into an object
 * @example
 *
 * [{a:'holo'}, {b:'world'}].reduce((acc, next) => ({...acc, ...next}), {}) // {a:'holo', b:'world'}
 * collapse([{a:'holo'}, {b:'world'}]) // {a:'holo', b:'world'}
 *
 * @param parts
 * @returns
 */
export function collapse<T>(parts: T[]): T {
  return Object.assign({}, ...parts);
}
